/**
 * Удаляет все falsy значения из массива.
 * (false, null, undefined, 0, '', NaN)
 *
 * @param array Массив, содержащий falsy значения
 * @typeParam T Тип элементов в массиве
 * @returns Массив с исключенными falsy значения
 * @example
 * ```typescript
 * import { compact } from '@direct-frontend/stdlib';
 *
 * compact([1, 2, '', false, 3, undefined]); // [1, 2, 3]
 * ```
 */
export function compact(array) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
    return array.filter(Boolean);
}
